import axios from '../requester';
import { API } from '../constants/api-urls';
import { AUTH_LEVEL } from 'common/constants/constants';

export const getRequiredScopes = async (
  provider,
  authorizationLevel = AUTH_LEVEL.ORGANIZATION,
  tokenType
) =>
  axios
    .get(`${API.REQUIRED_SCOPES_PATH}/${provider}`, {
      params: {
        authorization_level: authorizationLevel,
        ...(tokenType && { token_type: tokenType })
      }
    })
    .then(({ required_scopes }) => required_scopes);

export const premiumRequest = async () => axios.post(API.PREMIUM_REQUEST);
export const getConfiguration = async () => axios.get(API.CONFIGURATION_PATH);
